
<template>
  <div>
    <el-dialog :visible.sync="crisiscasesdialog" :before-close="cancellation" width="60%">
      <el-form :model="risiscasesData" ref="risiscasesData">
        <el-form-item style="text-align: center;padding: 10px 0;"><span style="font-weight: bold;font-size: 20px;">危机个案上报</span></el-form-item>
        <el-form-item style="border-bottom: 1px solid #d0d0d0;padding-bottom: 20px;">
          <el-row>
            <el-col :span="7">
              <label>咨询师</label><br/>
              <el-input v-model.trim="risiscasesData.TeachID" disabled style="width: 100%"></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>{{SourceFlg!='4'?'评估时间':'咨询时间'}}</label><br/>
              <el-date-picker v-if="SourceFlg!='4'" :disabled="isEdit" v-model="risiscasesData.EvaluationTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
              <el-input v-else v-model="risiscasesData.RecordTime" disabled></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">基本信息</el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="7">
              <label>姓名</label>
              <el-input v-model="UserName" disabled></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>学号</label>
              <el-input v-model="risiscasesData.UserID" disabled></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <label>所在院系/研究所</label>
              <el-input v-model="risiscasesData.DeptName" disabled></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <label>导师/心理辅导员联系方式</label>
              <el-input v-model="risiscasesData.Phone" disabled placeholder="请输入"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">危机评估</el-form-item>
        <el-form-item>
          <label>意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）</label>
          <el-input type="textarea" v-model="risiscasesData.Awareness" placeholder="请输入概要描述事件，不透露隐私内容" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>所处情境（所处位置/周围环境）</label>
          <el-input type="textarea" v-model="risiscasesData.Situations" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>自知力</label>
          <el-input type="textarea" v-model="risiscasesData.Insight" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>情绪状态（类型/强度等）</label>
          <el-input type="textarea" v-model="risiscasesData.EmotionalState" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>主要压力源（应激事件/应激反应）</label>
          <el-input type="textarea" v-model="risiscasesData.PressureSource" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 30px;"><span style="color: red;">*</span>风险等级</el-form-item>
        <el-form-item
        prop="FirstCrisis"
        :rules="{ required: true, message: '请选择风险等级', trigger: ['change'] }"
    >
          <el-radio v-model="risiscasesData.FirstCrisis" label="1" :disabled="isEdit">五级/严重而紧急</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="2" :disabled="isEdit">四级/重度</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="3" :disabled="isEdit">三级/中度</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="4" :disabled="isEdit">二级</el-radio>
          <el-radio v-model="risiscasesData.FirstCrisis" label="5" :disabled="isEdit">一级</el-radio>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">具体风险等级</el-form-item>
        <el-form-item>
          <el-row>自杀、自伤或伤害他人倾向</el-row>
          <el-row>
            <el-radio v-model="risiscasesData.SuicidalFlg" label="1" :disabled="isEdit">是</el-radio>
            <el-radio v-model="risiscasesData.SuicidalFlg" label="0" :disabled="isEdit">否</el-radio>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>自杀、自伤或伤害他人倾向</el-row>
          <el-row>
            <el-checkbox-group v-model="Damage" @change="handleCheckedDamageChange" :disabled="isEdit">
              <el-checkbox v-for="item in DamageList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
                <el-input v-model="Damageother" v-if="item.cDicValue=='其他'" :disabled="isEdit" @blur="handleCheckedDamageChange(Damage)" maxlength="50" show-word-limit></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>

          <el-row>关于自杀的方式</el-row>
          <el-row>
            <el-checkbox-group v-model="SuicideMethods" @change="handleCheckedSuicideMethodsChange" :disabled="isEdit">
              <el-checkbox v-for="item in SuicideMethodsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}} 
                <el-input v-model="SuicideMethodsother" :disabled="isEdit" v-if="item.cDicValue=='其他'" @blur="handleCheckedSuicideMethodsChange(SuicideMethods)" maxlength="50" show-word-limit></el-input>
              </el-checkbox>

            </el-checkbox-group>
          </el-row>

        </el-form-item>
        <el-form-item>
          <label>既往自杀相关经历（来访者/重要关系人）</label>
          <el-input type="textarea" v-model="risiscasesData.InjuryExperience" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>具体描述时间、情况、进程等</label>
          <el-input type="textarea" v-model="risiscasesData.SpecificTimeOne" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-row>疑似重性精神障碍</el-row>
          <el-row>
            <el-radio v-model="risiscasesData.PsychosesFlg" label="1" :disabled="isEdit">是</el-radio>
            <el-radio v-model="risiscasesData.PsychosesFlg" label="0" :disabled="isEdit">否</el-radio>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="SuspectedAppear" @change="handleCheckedSuspectedAppearChange" :disabled="isEdit">
              <el-checkbox v-for="item in SuspectedAppearList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>
          <label>具体描述时间、情况、进程等</label>
          <el-input type="textarea" v-model="risiscasesData.SpecificTimeTwo" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">基本信息</el-form-item>
        <el-form-item>
          <label>时间/医院/医师/诊断</label>
          <el-input type="textarea" v-model="risiscasesData.Timelocation" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>服药情况（药名 药量 是否遵医嘱服药）</label>
          <el-input type="textarea" v-model="risiscasesData.MedicineDescribe" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">社会支持系统情况</el-form-item>
        <el-form-item>
          <label>如：最信赖的人，与父母、朋友、导师的关系等</label>
          <el-input type="textarea" v-model="risiscasesData.SocialSupport" placeholder="请输入" maxlength="500" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">咨询师综合印象及建议</el-form-item>
        <el-form-item>
          <label>整体印象（对心理症状类型的评估及评估依据）</label>
          <el-input type="textarea" v-model="risiscasesData.OverallImpression" placeholder="请输入需包含社会支持系统概要情况" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <label>建议（长期咨询/通知家长/建议就医/遵医嘱服药）</label>
          <el-input type="textarea" v-model="risiscasesData.Recommendation" placeholder="请输入" maxlength="100" :disabled="isEdit" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="font-size: 22px;font-weight:bold;margin-top: 10px;">填表说明</el-form-item>
        <el-form-item>
          <el-row>感觉疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="SensoryProblems" @change="handleCheckedSensoryProblemsChange" :disabled="isEdit">
              <el-checkbox v-for="item in SensoryProblemsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>思维疑似出现</el-row>
          <el-row>
            <el-checkbox-group v-model="ThinkProblems" @change="handleCheckedThinkProblemsChange" :disabled="isEdit">
              <el-checkbox v-for="item in ThinkProblemsList" :label='`{"dicKey":"${item.dicKey}","cdicvalue":"${item.cDicValue}"}`' :key="item.dicKey">
                {{item.cDicValue}}
              </el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-form-item>
        <div v-if="pageNum==-1 || pageNum==-2">

          <!-- 咨询上报路线审批 -->
          <div v-if="SourceFlg=='4'">
            <!-- <div v-if="this.Global.pdroleid(1066) || this.Global.pdroleid(1068) || this.Global.pdroleid(1069) || this.Global.pdroleid(1070)">
            <el-form-item class="bgfbf2" label="">
              <el-row>咨询主管初审</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.consultDirectorChecks" :disabled="!this.Global.pdroleid(1066) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.consultDirectorCheckDetail" :disabled="!this.Global.pdroleid(1066) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1066) && pageNum!=-2">
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>
              <el-button type="primary" @click="submit(1)">提交风险监控员</el-button>
            </el-form-item>
          </div> -->

          <!-- 咨询上报路线驳回 -->
          <div v-if="SourceFlg=='4'">
            <!-- <div v-if="this.Global.pdroleid(1059)">
              <el-form-item class="bgfbf2" label="">
                <el-row>驳回意见</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.consultDirectorChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.consultDirectorCheckDetail" disabled="disabled" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </div> -->
            
            <!-- 咨询主管查看危机主管驳回 -->
            <!-- <div v-if="this.Global.pdroleid(1066)">
              <el-form-item class="bgfbf2" label="">
                <el-row>驳回意见222</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.criAdminChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.criAdminCheckDetail" disabled="disabled"></el-input>
              </el-form-item>
            </div> -->

            <!-- 危机主管查看风险监控员驳回意见 -->
            <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1069) || this.Global.pdroleid(1070)">
              <el-form-item class="bgfbf2" label="">
                <el-row>风险监控员初核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.riskMonitorChecks"  :disabled="!this.Global.pdroleid(1069) || pageNum==-2">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.riskMonitorCheckDetail" :disabled="!this.Global.pdroleid(1069) || pageNum==-2"></el-input>
              </el-form-item>
              <div v-if="this.Global.pdroleid(1069)">
                <el-form-item style="margin: 20px 0;" v-if="pageNum!=-2 && paramscrisis.feedBackState != 4"> 
                  <el-button type="primary" @click="submit(2)">审核驳回</el-button>              
                  <el-button type="primary" @click="submit(3)">提交危机主管</el-button>   
                </el-form-item>
              </div> 
            </div> 
            <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1069) || this.Global.pdroleid(1070)">
              <el-form-item class="bgfbf2" label="">
                <el-row>危机主管复核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.criAdminChecks" :disabled="!this.Global.pdroleid(1068) || pageNum==-2">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" :disabled="!this.Global.pdroleid(1068) || pageNum==-2" v-model="paramscrisis.criAdminCheckDetail" maxlength="500" show-word-limit></el-input>
              </el-form-item>
              <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1068) && pageNum!=-2 && paramscrisis.feedBackState != 3">
                <el-button type="primary" @click="submit(1)">审核确认</el-button>
                <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                <el-button type="primary" @click="submit(3)">提交中心主任</el-button>                
              </el-form-item> 
            </div>  
            <!-- 危机主管查看中心主任驳回意见 -->
            <div v-if="this.Global.pdroleid(1068)">
              <el-form-item class="bgfbf2" label="">
                <el-row>中心主任审批</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.centerDirectorChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.centerDirectorCheckDetail" disabled="disabled"></el-input>
              </el-form-item>
            </div> 
          </div>
          
          <!-- 无法确定路线驳回 -->
          <div v-else-if="reportStatus=='无法确定' || urgentStatus=='' || urgentStatus==null">
            <!-- 咨询师查看咨询主管驳回意见 -->
            <div v-if="this.Global.pdroleid(1059)">
              <el-form-item class="bgfbf2" label="">
                <el-row>咨询师评估</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.consultDirectorChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.consultDirectorCheckDetail" disabled="disabled"></el-input>
              </el-form-item>
            </div> 
          </div>

          <!-- 其他正常流程路线驳回 -->
          <div v-else>
            <!-- 风险监控员查看危机主管驳回意见 -->
            <div v-if="this.Global.pdroleid(1069)">
              <el-form-item class="bgfbf2" label="">
                <el-row>危机主管复核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.criAdminChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.criAdminCheckDetail" disabled="disabled"></el-input>
              </el-form-item>
            </div>

            <!-- 危机主管查看中心主任驳回意见 -->
            <div v-if="this.Global.pdroleid(1068)">
              <el-form-item class="bgfbf2" label="">
                <el-row>中心主任审批</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.centerDirectorChecks"  disabled="disabled">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.centerDirectorCheckDetail" disabled="disabled"></el-input>
              </el-form-item>
            </div>
          </div> 

          <!-- <div v-if="this.Global.pdroleid(1069)">
            
            <el-form-item class="bgfbf2" label="">
              <el-row>风险监控员初核1111</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.riskMonitorChecks" :disabled="pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.riskMonitorCheckDetail" :disabled="pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item style="margin: 20px 0;" v-if="pageNum!=-2">
              <el-button type="primary" @click="submit(4)">审核确认</el-button>
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>              
              <el-button type="primary" @click="submit(3)">提交危机主管</el-button>   
            </el-form-item>
          </div>  -->
          
          <div v-if="this.Global.pdroleid(1070) ">
            <el-form-item class="bgfbf2" >
              <el-row>中心主任审批</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.centerDirectorChecks" :disabled="!this.Global.pdroleid(1070) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.centerDirectorCheckDetail" :disabled="!this.Global.pdroleid(1070) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1070) && pageNum!=-2">
              <el-button type="primary" @click="submit(1)">审核确认</el-button>
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>
            </el-form-item>
          </div>
          </div>

          <!-- 无法确定路线审批 -->
          <div v-else-if="reportStatus=='无法确定' || urgentStatus=='' || urgentStatus==null">
            <div v-if="(this.Global.pdroleid(1068) || this.Global.pdroleid(1069)) && Tstate!=1">
              <el-form-item class="bgfbf2" label="">
                <el-row>风险监控员初核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.riskMonitorChecks"  :disabled="!this.Global.pdroleid(1069) || pageNum==-2">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>

              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.riskMonitorCheckDetail" :disabled="!this.Global.pdroleid(1069) || pageNum==-2" maxlength="500" show-word-limit></el-input>
              </el-form-item>

              <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1069) && pageNum!=-2">
                <div v-if="reportStatus=='无法确定' || urgentStatus=='' || urgentStatus==null">
                  <el-button type="primary" @click="submit(4)">审核确认</el-button>
                  <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                </div>
                <div v-else>
                  <el-button type="primary" @click="submit(1)">审核确认</el-button>
                  <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                  <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
                </div>
              </el-form-item>
            </div>

            <div v-if="(this.Global.pdroleid(1068) || this.Global.pdroleid(1069)) && Tstate==1">
              <el-form-item class="bgfbf2" label="">
                <el-row>风险监控员初核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.riskMonitorChecks"  :disabled="!this.Global.pdroleid(1069) || pageNum==-2">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>

              <el-form-item>
                <el-input type="textarea" v-model="paramscrisis.riskMonitorCheckDetail" :disabled="!this.Global.pdroleid(1069) || pageNum==-2" maxlength="500" show-word-limit></el-input>
              </el-form-item>

              <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1069) && pageNum!=-2">
                <div v-if="reportStatus=='无法确定' || urgentStatus=='' || urgentStatus==null">                 
                  <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                  <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
                </div>
              </el-form-item>
            </div>

            <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1069) || this.Global.pdroleid(1070)">
              <el-form-item class="bgfbf2" label="">
                <el-row>危机主管复核</el-row>
                <el-row>
                  <el-checkbox-group :max="3" v-model="paramscrisis.criAdminChecks" :disabled="!this.Global.pdroleid(1068) || pageNum==-2">
                    <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                    <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                    <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                    <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                  </el-checkbox-group>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-input type="textarea" :disabled="!this.Global.pdroleid(1068) || pageNum==-2" v-model="paramscrisis.criAdminCheckDetail" maxlength="500" show-word-limit></el-input>
              </el-form-item>
              <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1068) && pageNum!=-2">
                <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                <el-button type="primary" @click="submit(5)" v-if="Tstate=='1'">提交风险监控员</el-button>
              </el-form-item>
            </div>


            <!-- <div v-if="this.Global.pdroleid(1066) || this.Global.pdroleid(1068)">
            <el-form-item class="bgfbf2" label="">
              <el-row>咨询主管初审</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.consultDirectorChecks" :disabled="!this.Global.pdroleid(1066) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.consultDirectorCheckDetail" :disabled="!this.Global.pdroleid(1066) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1066) && pageNum!=-2">
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>
              <el-button type="primary" @click="submit(1)">提交风险监控员</el-button>
            </el-form-item>
          </div> -->
          </div>

          <!-- 其他正常流程审批 -->
          <div v-else> 

          <div v-if="this.Global.pdroleid(1069) || this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
            
            <el-form-item class="bgfbf2" label="">
              <el-row>风险监控员初核</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.riskMonitorChecks"  :disabled="!this.Global.pdroleid(1069) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>

            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.riskMonitorCheckDetail" :disabled="!this.Global.pdroleid(1069) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1069) && pageNum!=-2">
              <div v-if="reportStatus=='无法确定' || urgentStatus=='' || urgentStatus==null">
                <el-button type="primary" @click="submit(4)">审核确认</el-button>
                <el-button type="primary" @click="submit(2)">审核驳回</el-button>
              </div>
              <div v-else>
                <el-button type="primary" @click="submit(1)">审核确认</el-button>
                <el-button type="primary" @click="submit(2)">审核驳回</el-button>
                <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
              </div>
              
            </el-form-item>

          </div>
          
          <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
            <el-form-item class="bgfbf2" label="">
              <el-row>危机主管复核</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.criAdminChecks" :disabled="!this.Global.pdroleid(1068) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-input type="textarea" :disabled="!this.Global.pdroleid(1068) || pageNum==-2" v-model="paramscrisis.criAdminCheckDetail" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1068) && pageNum!=-2">
              <el-button type="primary" @click="submit(1)" v-if="SourceFlg!='4' && Tstate=='0'">审核确认</el-button>
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>
              <el-button type="primary" @click="submit(3)" v-if="Tstate!='1' && Reporttype!='日常危机'">提交中心主任</el-button>
              <el-button type="primary" @click="submit(1)" v-if="SourceFlg=='4'">提交风险监控员</el-button>
              <el-button type="primary" @click="submit(5)" v-else-if="Tstate=='1'">提交风险监控员</el-button>
            </el-form-item>

            
          </div>
          
          <div v-if="this.Global.pdroleid(1070)">
            <el-form-item class="bgfbf2" >
              <el-row>中心主任审批</el-row>
              <el-row>
                <el-checkbox-group :max="3" v-model="paramscrisis.centerDirectorChecks"  :disabled="!this.Global.pdroleid(1070) || pageNum==-2">
                  <el-checkbox label="1" name="type">信息不完整</el-checkbox>
                  <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
                  <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
                  <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
                </el-checkbox-group>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-input type="textarea" v-model="paramscrisis.centerDirectorCheckDetail"  :disabled="!this.Global.pdroleid(1070) || pageNum==-2" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item style="margin: 20px 0;" v-if="this.Global.pdroleid(1070) && pageNum!=-2">
              <el-button type="primary" @click="submit(1)" v-if="Tstate!='1'">审核确认</el-button>
              <el-button type="primary" @click="submit(2)">审核驳回</el-button>
            </el-form-item>
          </div>

          </div>
      </div>
      </el-form>
      <div style="text-align: right;margin: 30px 0;" v-if="pageNum>=0">
        <el-button @click="canceldia">取 消</el-button>
        <el-button v-if="SourceFlg=='4'" type="primary" @click="confirmClick(2)" :disabled="isEdit">保 存</el-button>
        <el-button type="primary" @click="confirmClick(1)" :disabled="isEdit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name:"Crisiscases",
  data(){
    return{
      RoleID:sessionStorage.getItem('RoleID'),
      crisiscasesdialog:false,
      UserName:'',
      SourceFlg:'',
      reportStatus:'',
      urgentStatus:'',
      Reporttype:'',
      estimate:true,
      risiscasesData: {
        Type:'1',//1.提交   2.保存
        TeachID:'',
        RecordTime:'',
        RealName:'',
        UserID:'',
        Phone:'',
        DeptName:'',
        Awareness:'',
        Situations:'',
        Insight:'',
        EmotionalState:'',
        PressureSource:'',
        FirstCrisis:'',
        InjuryTendency:[],
        SuicideMethods:[],
        InjuryExperience:'',
        SpecificTimeOne:'',
        PsychosesFlg:'',
        SuspectedAppearance:[],
        SpecificTimeTwo:'',
        Timelocation:"",
        MedicineDescribe:'',
        SocialSupport:'',
        OverallImpression:'',
        Recommendation:'',
        SensoryProblems:[],
        ThinkProblems:[],
        KeyNo:'',
        EvaluationTime:''
      },
      Damage:[],
      DamageList:[],
      Damageother:'',
      SuicideMethods:[],
      SuicideMethodsList:[],
      SuicideMethodsother:'',
      SuspectedAppear:[],
      SuspectedAppearList:[],
      SensoryProblems:[],
      SensoryProblemsList:[],
      ThinkProblems:[],
      ThinkProblemsList:[],
      isEdit:true,
      pageNum:0,
      paramscrisis:{
        keyNo:'',
        type:'咨询上报',
        operate:'',
        riskMonitorChecks:[],
        consultDirectorChecks:[],
        riskMonitorCheckDetail:'',
        consultDirectorCheckDetail:'',
        criAdminChecks:[],
        criAdminCheckDetail:'',
        centerDirectorChecks:[],
        centerDirectorCheckDetail:'',
        criAdminHandle:'',
        riskMonitorHandle:'',
        feedBackState:''
      },

    }
  },
  mounted() {
    this.init();
  },
  methods:{
    // 关闭弹窗
    cancellation(done){
      var _this=this;
      this.$confirm('确认关闭？').then(_ => {
            done();
            _this.risiscasesData= _this.$options.data().risiscasesData;
            _this.crisiscasesdialog=false;
            _this.$parent.Init();
          }).catch(_ => {
            
          });
      },
      canceldia(){
        this.risiscasesData=this.$options.data().risiscasesData;
        this.crisiscasesdialog=false;
        this.$parent.Init();
      },
    // 自杀自伤伤害倾向选项
    handleCheckedDamageChange(value){
      this.risiscasesData.InjuryTendency=[];
      for(let item of value){
        let str=JSON.parse(item);
        if(str.cdicvalue=='其他'){
          str.dicKey+=','+this.Damageother;
          this.risiscasesData.InjuryTendency.push(str);
        }else{
          this.risiscasesData.InjuryTendency.unshift(str);
        }
      };
    },
    handleCheckedSuicideMethodsChange(value){
      this.risiscasesData.SuicideMethods=[];
      for(let item of value){
        let str=JSON.parse(item);
        if(str.cdicvalue=='其他'){
          str.dicKey+=','+this.SuicideMethodsother;
          this.risiscasesData.SuicideMethods.push(str);
        }else{
          this.risiscasesData.SuicideMethods.unshift(str);
        }
      }
    },
    handleCheckedSuspectedAppearChange(value){
      this.risiscasesData.SuspectedAppearance=[];
      for(let item of value){
        this.risiscasesData.SuspectedAppearance.push(JSON.parse(item))
      }
    },
    handleCheckedSensoryProblemsChange(value){
      this.risiscasesData.SensoryProblems=[];
      for(let item of value){
        this.risiscasesData.SensoryProblems.push(JSON.parse(item))
      }
    },
    handleCheckedThinkProblemsChange(value){
      this.risiscasesData.ThinkProblems = [];
      for(let item of value){
        this.risiscasesData.ThinkProblems.push(JSON.parse(item))
      }
    },
    // 预约记录页危机上报弹窗
    Detail(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.SourceFlg='4';
      this.pageNum=num;
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=e.Tstate=="1"?true:false;
      this.risiscasesData.TeachID=e['ConUserName'];
      this.risiscasesData.RecordTime=e['ConsultTime'];
      this.risiscasesData.RealName=e['UserName'];
      this.UserName=e.UserName;
      this.risiscasesData.UserID=e['UserID'];
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.AppointmentID=e['AppointmentID'];
      this.crisiscasesdialog=true;
      if(e.Tstate!=null){
        this.consultationReport(e,num);
      }else{
        this.GetDictionaryList();
      }
    },
    // 危机上报页面危机上报弹窗
    CrisisreporDetail(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Tstate=e.Tstate;
      this.pageNum=num;
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=e.Tstate=="1" || this.RoleID!="1059"?true:false;
      this.crisiscasesdialog=true;;
      if(e.sourceNo!=null){
        this.ConsultationAndCrisisReport(e);
      }else{
        this.GetDictionaryList();
      }
    },

    // 驳回原因不可编辑
    Crisisreporreject(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Tstate=e.Tstate;
      this.pageNum=num;
      if(num==-1 ||num==-2){
        this.prefabricatedTableData(e.KeyNo);
      }
      this.init();
      this.isEdit=true;
      this.crisiscasesdialog=true;;
      if(e.sourceNo!=null){
        this.ConsultationAndCrisisReport(e);
      }else{
        this.GetDictionaryList();
      }
    },

    // 危机上报无法确定弹窗
    Unabledetermine(e,num){
      this.paramscrisis.keyNo=e.KeyNo;
      this.paramscrisis.type=e.type;
      this.Reporttype=e.type;
      this.pageNum=num;
      this.Tstate=e.Tstate;
      this.prefabricatedTableData(e.KeyNo);
      this.isEdit=e.Tstate=="1" || this.RoleID!="1059"?true:false;
      this.crisiscasesdialog=true;
      this.risiscasesData.TeachID=e['ConUserName'];
      this.risiscasesData.RecordTime=e['ConsultTime'];
      this.risiscasesData.RealName=e['UserName'];
      this.UserName=e.UserName;
      this.risiscasesData.UserID=e['UserID'];
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.AppointmentID=e['AppointmentID'];
      this.$Http_Post('/management/distressPrediction/ConsultationUnableConfirmData',{KeyNo:e.KeyNo}).then(res=>{
        if(res.Code==0){
          this.risiscasesData=res.Data;
          this.risiscasesData.RealName=e['realName'];
          this.risiscasesData.UserID=res.Data['UserID'];
          this.risiscasesData.SourceNo=e['sourceNo'];
          this.UserName=res.Data.UserName;
          this.risiscasesData.RecordTime=res.Data['ConsultTime'];
          this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
          this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
          this.GetDictionaryList();
        }else{
          this.$message.error(res.Message);
        }
      });
    },

    // 危机上报咨询师评估
    Consultantevaluation(e){
      this.crisiscasesdialog=true;;
      this.estimate=false;
      this.risiscasesData.TeachID=e['ConsultantName'];
      this.risiscasesData['SourceFlag']=1;
      this.risiscasesData.Phone=e['Phone'];
      this.risiscasesData.RealName=e['realName'];
      this.risiscasesData.UserID=e['userId'];
      this.risiscasesData.SourceNo=e['sourceNo'];
      this.risiscasesData.KeyNo=e['KeyNo'];
      this.UserName=e.realName;
      this.risiscasesData.DeptName=e['deptName'];
      this.risiscasesData.EvaluationTime=this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss');
      this.isEdit=e.reportStatus=='待咨询师评估'?false:true;
      this.GetDictionaryList();
    },

    // 危机干预咨询师评估
    interveneConsultantevaluation(e){
      this.crisiscasesdialog=true;;
      this.estimate=false;
      this.risiscasesData['SourceFlag']=2;
      this.risiscasesData.TeachID=e['ConsultantName'];
      this.risiscasesData.Phone=e['phone'];
      this.risiscasesData.RealName=e['RealName'];
      this.risiscasesData.UserID=e['UserId'];
      this.risiscasesData.SourceNo=e['SourceNo'];
      this.risiscasesData.KeyNo=e['KeyNo'];
      this.UserName=e.RealName;
      this.risiscasesData.DeptName=e['DeptName'];
      this.risiscasesData.EvaluationTime=this.Global.formatDate(new Date(),'YYYY-MM-DD HH:mm:ss');
      this.isEdit=e.RecordStatus=='待咨询师评估'?false:true;
      this.GetDictionaryList();
    },

    // 危机上报审核回显
    prefabricatedTableData(val){
      this.$Http_Post('management/distressPrediction/prefabricatedTableData',{keyNo:val}).then(res=>{
        if(res.Code==0 || res.Code==200){
          // this.paramscrisis=res.Data;
          this.reportStatus=res.Data.reportStatus;
          this.urgentStatus=res.Data.urgentStatus;
          this.SourceFlg=res.Data.SourceFlg;
          this.paramscrisis.consultDirectorChecks=res.Data.consultDirectorChecks==null?[]:res.Data.consultDirectorChecks;
          this.paramscrisis.consultDirectorCheckDetail=res.Data.consultDirectorCheckDetail==null?[]:res.Data.consultDirectorCheckDetail;
          this.paramscrisis.criAdminChecks=res.Data.criAdminChecks;
          this.paramscrisis.criAdminCheckDetail=res.Data.criAdminCheckDetail;
          this.paramscrisis.centerDirectorChecks=res.Data.centerDirectorChecks;
          this.paramscrisis.centerDirectorCheckDetail=res.Data.centerDirectorCheckDetail;
          this.paramscrisis.riskMonitorChecks=res.Data.riskMonitorChecks;
          this.paramscrisis.riskMonitorCheckDetail=res.Data.riskMonitorCheckDetail;
          this.paramscrisis.criAdminHandle=res.Data.CriAdminHandle;
          this.paramscrisis.riskMonitorHandle=res.Data.RiskMonitorHandle;
          this.paramscrisis.feedBackState=res.Data.FeedBackState; 
        }
      });
    },
    //危机上报页面回显用
    ConsultationAndCrisisReport(e){
      this.$Http_Post('/management/distressPrediction/ConsultationAndCrisisReportData',{SourceNo:e.sourceNo}).then(res=>{
        if(res.Code==0){
          this.risiscasesData=res.Data;
          this.risiscasesData.RealName=e['realName'];
          this.risiscasesData.UserID=res.Data['UserID'];
          this.risiscasesData.SourceNo=e['sourceNo'];
          this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
          this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
          this.UserName=res.Data.UserName;
          this.risiscasesData.RecordTime=res.Data['ConsultTime'];
          this.GetDictionaryList();
        }else{
          this.$message.error(res.Message);
        }
      })
    },
  // 预约记录页面回显用
    consultationReport(e,num){
          this.$Http_Post('/management/distressPrediction/consultationReportData/',{AppointmentID:e.AppointmentID}).then(res=>{
            if(res.Code==0){
              this.risiscasesData=res.Data;
              this.risiscasesData.AppointmentID=e['AppointmentID'];
              this.risiscasesData.InjuryTendency=res.Data.InjuryTendencys;
              this.risiscasesData.SuspectedAppearance=res.Data.SuspectedAppearances;
              this.risiscasesData.UserID=e['UserID'];
              this.risiscasesData.RecordTime=e['ConsultTime'];
              this.risiscasesData.Phone=e['Phone'];
              this.risiscasesData.DeptName=e['DeptName'];
              this.risiscasesData.RealName=res.Data['UserName'];
              this.risiscasesData.KeyNo=e.KeyNo;
              this.GetDictionaryList();
            }else{
              this.$message.error(res.Message);
            }
      })
    },

  //   获取字典表数据
    GetDictionaryList(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'31'}).then(res=>{
        if(res.Code==0){
          this.DamageList=res.Data;
          this.getSuicideMethods();
          if(this.risiscasesData.InjuryTendency!=undefined){
            for(var i=0;i<this.risiscasesData.InjuryTendency.length;i++){
              for(let list of res.Data){
                if(this.risiscasesData.InjuryTendency[i]==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  if(list.cDicValue=='其他' && this.risiscasesData.InjuryTendency[i+1]){
                    this.Damageother=this.risiscasesData.InjuryTendency[i+1];
                  }
                  this.Damage.push(str);
                }
              }
            }
            this.handleCheckedDamageChange(this.Damage);
          }
        }
      });
    },

    getSuicideMethods(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'32'}).then(res=>{
        if(res.Code==0){
          this.SuicideMethodsList=res.Data;
          this.getSuspectedAppear();
          if(this.risiscasesData.SuicideMethodses!=undefined){
            for(var i=0;i<this.risiscasesData.SuicideMethodses.length;i++){
              for(let list of res.Data){
                if(this.risiscasesData.SuicideMethodses[i]==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  if(list.cDicValue=='其他' && this.risiscasesData.SuicideMethodses[i+1]){
                    this.SuicideMethodsother=this.risiscasesData.SuicideMethodses[i+1];
                  }
                  this.SuicideMethods.push(str);
                }
              }
            }
            this.handleCheckedSuicideMethodsChange(this.SuicideMethods);
          }
        }
      });
    },

    //
    getSuspectedAppear(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'33'}).then(res=>{
        if(res.Code==0){
          this.SuspectedAppearList=res.Data;
          this.getSensoryProblems();
          if(this.risiscasesData.SuspectedAppearance!=undefined){
            for(let item of this.risiscasesData.SuspectedAppearance){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.SuspectedAppear.push(str);
                }
              }
            }
            this.handleCheckedSuspectedAppearChange(this.SuspectedAppear);
          }
        }
      });
    },
    getSensoryProblems(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'34'}).then(res=>{
        if(res.Code==0){
          this.SensoryProblemsList = res.Data;
          
          this.getThinkProblems();
          if(this.risiscasesData.SensoryProblemses!=undefined){
            for(let item of this.risiscasesData.SensoryProblemses){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.SensoryProblems.push(str);
                }
              }
            }
            this.handleCheckedSensoryProblemsChange(this.SensoryProblems);
          }
        }
      });
    },
    getThinkProblems(){
      this.$Http_Post('/User/GetDictionaryList/',{DicTypCode:'35'}).then(res=>{
        if(res.Code==0){
          this.ThinkProblemsList=res.Data;
          if(this.risiscasesData.ThinkProblemses!=undefined){
            for(let item of this.risiscasesData.ThinkProblemses){
              for(let list of res.Data){
                if(item==list.dicKey){
                  let str=`{"dicKey":"${list.dicKey}","cdicvalue":"${list.cDicValue}"}`;
                  this.ThinkProblems.push(str);
                }
              }
            }
            this.handleCheckedThinkProblemsChange(this.ThinkProblems);
          }
        }
      });
    },
    confirmClick(type){
      this.$refs['risiscasesData'].validate((valid) => {
          if (valid) {
            this.risiscasesData['Type']=type;
            this.$Http_Post('/DistressPrediction/ConsultationReport/',this.risiscasesData).then(res=>{
              if(res.Code==0){
                this.$message({
                  type: 'success',
                  message:res.Message,
                });
                this.crisiscasesdialog=false;
                this.$parent.Init();
              }else{
                this.$message({ type: 'error', message:res.Message});
              }
            });
          }else{
            this.$message({ type: 'warning', message:"请选择风险等级"});
          }
        });
      
    },
    // 审核意见
    submit(val) {
      this.paramscrisis.operate=val;
      this.$Http_Post('/DistressPrediction/DailyRiskMonitors',this.paramscrisis).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({type: 'success',  message:res.Message});
          this.crisiscasesdialog=false;
          this.$parent.Init();
        }else{
          this.$message({type: 'error',  message:'提交失败'});
        }
      });
    },
    init(){
      this.Damage=[]
      this.DamageList=[]
      this.Damageother=''
      this.SuicideMethods=[]
      this.SuicideMethodsList=[]
      this.SuicideMethodsother=''
      this.SuspectedAppear=[]
      this.SuspectedAppearList=[]
      this.SensoryProblems=[]
      this.SensoryProblemsList=[]
      this.ThinkProblems=[]
      this.ThinkProblemsList=[]
      this.risiscasesData.InjuryTendency=[];
      this.risiscasesData.SuicideMethods=[];
      this.risiscasesData.SuspectedAppear=[];
      this.risiscasesData.SensoryProblems=[];
      this.risiscasesData.ThinkProblems=[];
      this.risiscasesData=this.$options.data().risiscasesData;
    }
  }
}

</script>
<style scoped>
.el-form-item{margin:0;line-height: 30px;}
.el-textarea__inner{width: 100%!important;}
.AppointmentList .el-dialog__body .el-form-item__content span{margin-left: 0!important;}
.el-row{margin: 0;}
</style>